import React from "react";
import {PrimaryCollapsibleSection} from "../../../../../elements/collapsableSection/primary/PrimaryCollapsibleSection";
import {CardField, SignPosition} from "./components/CardField";
import {ReturnedVehicleValuationChatEventDTO} from "../../../../../../api/generated";
import {getVehicleConditionTitle, getVehicleServiceHistoryTitle} from "../../../../../../utils/enumValueTitleUtil";

const StringList: React.FC<{ items: string[] }> = ({ items }) => (
    items.length ? <ul style={{ margin: 0, paddingLeft: '1.25rem', fontSize: '14px' }}>{items.map((t, i) => <li key={i}>{t}</li>)}</ul> : null
);

interface CustomerVehicleValuationChatEventCardProps {
    returnedVehicleValuationChatEvent: ReturnedVehicleValuationChatEventDTO
}

export const CustomerVehicleValuationChatEventCard: React.FC<CustomerVehicleValuationChatEventCardProps> = ({
                                                                                                                returnedVehicleValuationChatEvent
                                                                                                            }) => {
    const conditions = (returnedVehicleValuationChatEvent.valuated_vehicle_matched_conditions);

    const getOutstandingFinance = (): string | number => {
        const outstandingFinance = returnedVehicleValuationChatEvent.valuated_vehicle_outstanding_finances

        if (!outstandingFinance || outstandingFinance === 0) {
            return "0"
        }

        return outstandingFinance
    }

    return <PrimaryCollapsibleSection title={"Customer Vehicle Valuation"}>
        <CardField
            title="VRM"
            value={returnedVehicleValuationChatEvent.user_vehicle_vrm}
        />
        <CardField
            title="Mileage"
            value={returnedVehicleValuationChatEvent.valuated_vehicle_mileage}
        />
        <CardField
            title="Condition"
            value={getVehicleConditionTitle(returnedVehicleValuationChatEvent.valuated_vehicle_condition)}
        />
        <CardField
            title="Service History"
            value={getVehicleServiceHistoryTitle(returnedVehicleValuationChatEvent.valuated_vehicle_service_history)}
        />
        <CardField
            title="Outstanding Finance"
            value={getOutstandingFinance()}
            sign={"£"}
            signPosition={SignPosition.START}
        />
        {returnedVehicleValuationChatEvent.valuation_error_message ?
            (
                <>{returnedVehicleValuationChatEvent.valuation_error_message && <CardField
                    title="Error message"
                    value={returnedVehicleValuationChatEvent.valuation_error_message}
                />}</>
            )
            :
            (
                <>
                    <CardField
                        title="Valuation Gross Cost"
                        value={returnedVehicleValuationChatEvent.valuated_vehicle_gross_cost}
                        sign={"£"}
                        signPosition={SignPosition.START}
                    />
                    <CardField
                        title="Valuation Net Cost"
                        value={returnedVehicleValuationChatEvent.valuated_vehicle_net_cost}
                        sign={"£"}
                        signPosition={SignPosition.START}
                    />
                </>
            )
        }

        {conditions?.length && (
            <CardField
                title="Matched Conditions"
                valueComponent={StringList}
                props={{ items: conditions }}
            />
        )}

    </PrimaryCollapsibleSection>
}
